/* globals Shopify */

// #region Imports
import fr from '@js/i18n/fr';

// #endregion

const DEFAULT_LOCALE = 'fr';
const { locale } = Shopify;

export function isDefaultLocale() {
  return locale === DEFAULT_LOCALE;
}

export async function i18nLoad() {
  if (!isDefaultLocale()) {
    const currLocale = 'en';
    const translations = await import(
      /* webpackChunkName: "translations" */
      `@js/i18n/${currLocale}.json`
    );
    return { ...fr, ...translations };
  }
  return fr;
}
